/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Not_Item_2Inputs */

const es_privacy_policy_scope_not_item_2 = /** @type {(inputs: Privacy_Policy_Scope_Not_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practicas de privacidad de los proveedores de servicios conectados (Google, Microsoft, Dropbox, etc.)`)
};

const en_privacy_policy_scope_not_item_2 = /** @type {(inputs: Privacy_Policy_Scope_Not_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy practices of connected service providers (Google, Microsoft, Dropbox, etc.)`)
};

/**
* | output |
* | --- |
* | "Privacy practices of connected service providers (Google, Microsoft, Dropbox, etc.)" |
*
* @param {Privacy_Policy_Scope_Not_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_not_item_2 = /** @type {((inputs?: Privacy_Policy_Scope_Not_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Not_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_not_item_2(inputs)
	return en_privacy_policy_scope_not_item_2(inputs)
});
export { privacy_policy_scope_not_item_2 as "privacy_policy.scope.not_item_2" }